import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _MediaTypeInput;

import * as Permissions from 'expo-permissions';
import { PermissionStatus } from 'unimodules-permissions-interface';
import uuidv4 from 'uuid/v4';
import { MediaTypeOptions } from "./ImagePicker.types";
var MediaTypeInput = (_MediaTypeInput = {}, _defineProperty(_MediaTypeInput, MediaTypeOptions.All, 'video/mp4,video/quicktime,video/x-m4v,video/*,image/*'), _defineProperty(_MediaTypeInput, MediaTypeOptions.Images, 'image/*'), _defineProperty(_MediaTypeInput, MediaTypeOptions.Videos, 'video/mp4,video/quicktime,video/x-m4v,video/*'), _MediaTypeInput);
export default {
  get name() {
    return 'ExponentImagePicker';
  },

  launchImageLibraryAsync: function launchImageLibraryAsync(_ref) {
    var _ref$mediaTypes, mediaTypes, _ref$allowsMultipleSe, allowsMultipleSelection;

    return _regeneratorRuntime.async(function launchImageLibraryAsync$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$mediaTypes = _ref.mediaTypes, mediaTypes = _ref$mediaTypes === void 0 ? MediaTypeOptions.All : _ref$mediaTypes, _ref$allowsMultipleSe = _ref.allowsMultipleSelection, allowsMultipleSelection = _ref$allowsMultipleSe === void 0 ? false : _ref$allowsMultipleSe;
            _context.next = 3;
            return _regeneratorRuntime.awrap(openFileBrowserAsync({
              mediaTypes: mediaTypes,
              allowsMultipleSelection: allowsMultipleSelection
            }));

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, null, null, null, Promise);
  },
  launchCameraAsync: function launchCameraAsync(_ref2) {
    var _ref2$mediaTypes, mediaTypes, _ref2$allowsMultipleS, allowsMultipleSelection;

    return _regeneratorRuntime.async(function launchCameraAsync$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref2$mediaTypes = _ref2.mediaTypes, mediaTypes = _ref2$mediaTypes === void 0 ? MediaTypeOptions.All : _ref2$mediaTypes, _ref2$allowsMultipleS = _ref2.allowsMultipleSelection, allowsMultipleSelection = _ref2$allowsMultipleS === void 0 ? false : _ref2$allowsMultipleS;
            _context2.next = 3;
            return _regeneratorRuntime.awrap(openFileBrowserAsync({
              mediaTypes: mediaTypes,
              allowsMultipleSelection: allowsMultipleSelection,
              capture: true
            }));

          case 3:
            return _context2.abrupt("return", _context2.sent);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, null, null, null, Promise);
  },
  getCameraPermissionAsync: function getCameraPermissionAsync() {
    return _regeneratorRuntime.async(function getCameraPermissionAsync$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", Permissions.getAsync(Permissions.CAMERA));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, null, null, null, Promise);
  },
  requestCameraPermissionsAsync: function requestCameraPermissionsAsync() {
    return _regeneratorRuntime.async(function requestCameraPermissionsAsync$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", Permissions.askAsync(Permissions.CAMERA));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, null, null, null, Promise);
  },
  getCameraRollPermissionsAsync: function getCameraRollPermissionsAsync() {
    return _regeneratorRuntime.async(function getCameraRollPermissionsAsync$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", permissionGrantedResponse());

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, null, null, null, Promise);
  },
  requestCameraRollPermissionsAsync: function requestCameraRollPermissionsAsync() {
    return _regeneratorRuntime.async(function requestCameraRollPermissionsAsync$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", permissionGrantedResponse());

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, null, null, null, Promise);
  }
};

function permissionGrantedResponse() {
  return {
    status: PermissionStatus.GRANTED,
    expires: 'never',
    granted: true,
    canAskAgain: true
  };
}

function openFileBrowserAsync(_ref3) {
  var mediaTypes = _ref3.mediaTypes,
      _ref3$capture = _ref3.capture,
      capture = _ref3$capture === void 0 ? false : _ref3$capture,
      _ref3$allowsMultipleS = _ref3.allowsMultipleSelection,
      allowsMultipleSelection = _ref3$allowsMultipleS === void 0 ? false : _ref3$allowsMultipleS;
  var mediaTypeFormat = MediaTypeInput[mediaTypes];
  var input = document.createElement('input');
  input.style.display = 'none';
  input.setAttribute('type', 'file');
  input.setAttribute('accept', mediaTypeFormat);
  input.setAttribute('id', uuidv4());

  if (allowsMultipleSelection) {
    input.setAttribute('multiple', 'multiple');
  }

  if (capture) {
    input.setAttribute('capture', 'camera');
  }

  document.body.appendChild(input);
  return new Promise(function (resolve, reject) {
    input.addEventListener('change', function () {
      if (input.files) {
        var targetFile = input.files[0];
        var reader = new FileReader();

        reader.onerror = function () {
          reject(new Error("Failed to read the selected media because the operation failed."));
        };

        reader.onload = function (_ref4) {
          var target = _ref4.target;
          var uri = target.result;
          resolve({
            cancelled: false,
            uri: uri,
            width: 0,
            height: 0
          });
        };

        reader.readAsDataURL(targetFile);
      } else {
        resolve({
          cancelled: true
        });
      }

      document.body.removeChild(input);
    });
    var event = new MouseEvent('click');
    input.dispatchEvent(event);
  });
}